import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import axios from "axios";
// functions
import { uniqueKey } from "../../functions/Random";
import { LoadingOutlined } from "@ant-design/icons";

let searchTime;
class BuyerSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      buyers: [],
      isMounted: false,
      isSearching: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onHandleCreatableSelect = this.onHandleCreatableSelect.bind(this);
    this.buyerSelected = this.buyerSelected.bind(this);
  }

  componentDidMount() {
    if (this.props.buyer.id) this.getCollection(this.props.buyer.id, "id");
    else this.getCollection();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.buyer.id != this.props.buyer.id && this.state.isMounted) {
      let selectOption = this.state.buyers.filter((option) => option.value == this.props.buyer.id)[0];
      this.props.onChange(this.props.buyer.id, selectOption);
    }
  }

  handleInputChange(value) {
    if (value !== "") {
      this.getCollection(value);
    }
  }

  setOptions(data) {
    let options = [];

    data.map((e) => {
      e.text = e.name;
      if (e.address) {
        e.text += ` - ${e.address.province.name} ${e.ship_to_code} ${e.sold_to_code && "(" + e.sold_to_code + ")"}`;
      }
      e.label = e.text;
      e.value = e.id;

      options.push(e);
    });
    this.setState({
      buyers: options,
      isMounted: true,
    });
  }

  getCollection(query, type = null) {
    let params = {
      sort: JSON.stringify(["id", "DESC"]),
      filter: {},
      range: JSON.stringify([0, 14]),
    };
    if (query && !type) params.filter.name = query;
    if (query && !type) params.filter.sold_to_code = query;
    if (type === "id") params.filter.id = query;

    if (query === "") {
      delete params.filter.name
      delete params.filter.sold_to_code
    }

    this.setOptions([]);
    this.setState({ isSearching: true });

    clearTimeout(searchTime);
    searchTime = setTimeout(
      () => {
        axios
          .get(`${process.env.REACT_APP_API_URL}/buyers`, {
            params: params,
          })
          .then((response) => {
            this.setOptions(response.data);
            this.setState({ isSearching: false });
          })
          .catch(function (error) {
            console.log(error);
            this.setState({ isSearching: false });
          });
      },
      query && !type ? 750 : 0
    );
  }

  buyerSelected(e) {
    let value = e.value;
    if (value !== this.props.buyer.id && this.state.isMounted) {
      this.props.onChange(value, e);
    }
  }

  onHandleCreatableSelect(e) {
    if (e) {
      if (e.__isNew__ !== undefined && e.id === undefined) {
        let buyers = this.state.buyers;
        e.id = uniqueKey();
        e.value = e.id;
        e.name = e.label;
        buyers.push(e);

        this.setState({ selected_name: e, buyers: buyers });
      }

      let value = e.value;
      if (value !== this.props.buyer.id && this.state.isMounted) {
        this.props.onChange(value, e);
      }
    } else {
      this.props.onChange(null, null);
    }
  }

  render() {
    const { isSearching } = this.state;

    if (this.props.creatable_select) {
      return (
        <CreatableSelect
          isClearable
          placeholder="พิมพ์ เพื่อค้นหา..."
          value={this.state.buyers.filter((option) => option.value === this.props.buyer.id)}
          onChange={this.onHandleCreatableSelect}
          onInputChange={this.handleInputChange}
          options={this.state.buyers}
          components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
        // menuPortalTarget={document.body}
        // maxMenuHeight={R_SEL_OPTION_MAX_H}
        />
      );
    } else {
      return (
        <div style={{ display: "flex", gap: 10, alignItems: "center", width: "100%" }}>
          {isSearching && <LoadingOutlined />}
          <Select
            className="select2-style custom-select-style"
            placeholder="พิมพ์ เพื่อค้นหา..."
            onChange={this.buyerSelected}
            onInputChange={this.handleInputChange}
            getOptionLabel={(option) => `${option.text}`}
            value={this.state.buyers.filter((option) => option.value === this.props.buyer.id)}
            getOptionValue={(option) => `${option.id}`}
            options={this.state.buyers}
            isDisabled={this.props.disabled}
          />
        </div>
      );
    }
  }
}

BuyerSelect.propTypes = {
  buyer: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default BuyerSelect;
